import { useContext } from "react";
import { AuthContext, type AuthContextState } from "../contexts";

/**
 * Provides the authentication context.
 * @returns The authentication context.
 */
export const useAuth = (): AuthContextState => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
};
